<app-header *ngIf="showHeader" [headerText]="headerText"></app-header>
<div class="nav-bar">
  <app-navbar *ngIf="showNavbar"></app-navbar>
</div>
<router-outlet></router-outlet>
<app-notification></app-notification>
<app-loader></app-loader>
